/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_ResultsInputs */

const en_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Results`)
};

const fr_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les résultats`)
};

const de_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse exportieren`)
};

const it_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta risultati`)
};

const ru_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты экспорта`)
};

const es_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados de exportación`)
};

const zh_cn2_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口结果`)
};

const ja_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート結果`)
};

const hi_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात परिणाम`)
};

const pt_pt2_export_results = /** @type {(inputs: Export_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultados da Exportação`)
};

/**
* | output |
* | --- |
* | "Export Results" |
*
* @param {Export_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const export_results = /** @type {((inputs?: Export_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_export_results(inputs)
	if (locale === "de") return de_export_results(inputs)
	if (locale === "it") return it_export_results(inputs)
	if (locale === "ru") return ru_export_results(inputs)
	if (locale === "es") return es_export_results(inputs)
	if (locale === "zh-CN") return zh_cn2_export_results(inputs)
	if (locale === "ja") return ja_export_results(inputs)
	if (locale === "hi") return hi_export_results(inputs)
	if (locale === "pt-PT") return pt_pt2_export_results(inputs)
	return en_export_results(inputs)
});